module.exports = __webpack_public_path__ + "img/nanfangdianwang.cae2e6b8.png";